export default __webpack_public_path__ + "static/media/Kuta-Beach.cf5442a8.jpg";